import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RefreshCw, CheckCircle2 } from "lucide-react";

export function GbpVerifyDialog({
  open, onOpenChange, gbpUrl, setGbpUrl, gbpRating, setGbpRating,
  gbpReviews, setGbpReviews, gbpSaving, verifyGbp,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="gbp-verify-dialog">
        <DialogHeader>
          <DialogTitle>Verify Google Business Profile</DialogTitle>
          <DialogDescription>
            Google's Places API can't see service-area businesses that hide their address.
            Paste this prospect's Google Maps / Business Profile link to mark it as claimed.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-1">
          <div className="space-y-1.5">
            <Label htmlFor="gbp-url" className="text-xs">Google Maps / Business Profile link</Label>
            <Input id="gbp-url" data-testid="gbp-url-input" placeholder="https://maps.app.goo.gl/..."
              value={gbpUrl} onChange={(e) => setGbpUrl(e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <Label htmlFor="gbp-rating" className="text-xs">Rating (optional)</Label>
              <Input id="gbp-rating" data-testid="gbp-rating-input" type="number" step="0.1" min="0" max="5"
                placeholder="4.8" value={gbpRating} onChange={(e) => setGbpRating(e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="gbp-reviews" className="text-xs">Reviews (optional)</Label>
              <Input id="gbp-reviews" data-testid="gbp-reviews-input" type="number" min="0"
                placeholder="120" value={gbpReviews} onChange={(e) => setGbpReviews(e.target.value)} />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={gbpSaving}>Cancel</Button>
          <Button onClick={verifyGbp} disabled={gbpSaving} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="gbp-verify-submit">
            {gbpSaving ? <RefreshCw className="w-4 h-4 animate-spin mr-1" /> : <CheckCircle2 className="w-4 h-4 mr-1" />} Verify
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
